import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/autoplay";
import { Mousewheel, Keyboard, Autoplay } from "swiper/modules";
import "swiper/css/mousewheel";
import "swiper/css/keyboard";
import { useMediaQuery } from "react-responsive";
import { ScrollArea, ScrollBar } from "../ui/scroll-area";
import { useEffect, useState } from "react";
import { GetRequest } from "@/lib/http";

const Promo = () => {
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const [slides, setSlides] = useState([]);

  useEffect(() => {
    const fetchSlides = async () => {
      const { data, err } = await GetRequest({ url: "/api/slides" });
      if (!err) {
        setSlides(data);
      } else {
        setSlides([]);
        console.error("Error fetching slides:", err);
      }
    };

    fetchSlides();
  }, []);

  return (
    <div className="mt-3">
      {isMobile ? (
        <Swiper
          slidesPerView={"auto"}
          spaceBetween={15}
          grabCursor={true}
          mousewheel={true}
          keyboard={{
            enabled: true,
          }}
          autoplay={{
            delay: 4500,
            disableOnInteraction: false,
          }}
          modules={[Mousewheel, Keyboard, Autoplay]}
          className="relative mt-6 w-full"
        >
          {slides.map((slide, index) => (
            <SwiperSlide
              key={index}
              style={{
                width: "95%",
                height: slides.length === 1 ? "100%" : "100px",
              }}
            >
              <a href={slide.link}>
                <img
                  src={slide.image}
                  alt=""
                  className="size-full rounded-lg object-cover"
                />
              </a>
            </SwiperSlide>
          ))}{" "}
        </Swiper>
      ) : (
        <ScrollArea className="max-w-[600px] lg:max-w-none">
          <div className="flex w-max space-x-5 pt-4 pb-3">
            {slides.map((slide, index) => (
              <div key={index} style={{ width: "363px", height: "100%" }}>
                <a href={slide.link}>
                  <img
                    src={slide.image}
                    alt=""
                    className="size-full rounded-lg object-cover"
                  />
                </a>
              </div>
            ))}
          </div>
          <ScrollBar orientation="horizontal" className="invisible" />
        </ScrollArea>
      )}
    </div>
  );
};

export default Promo;
